/* ==========================================================================
   KitaGrowthOil — theme.js
   Vanilla JS only. Uses Shopify's native AJAX Cart API (/cart/*.js).
   No frameworks, no Storefront API tokens.
   ========================================================================== */
(function () {
  "use strict";

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {
    addToCart: "Add to cart",
    soldOut: "Sold out",
    unavailable: "Unavailable",
    adding: "Adding…",
    cartError: "Unable to update the cart."
  };
  var cartRoot = routes.cart_url || "/cart";

  /* ---------------- helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + "." + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1]);
  }

  /* ---------------- sticky header ---------------- */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------------- drawers (mobile nav + cart) ---------------- */
  var lastFocused = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var main = document.getElementById("MainContent");
    if (main) main.setAttribute("inert", "");
    var focusable = drawer.querySelector("button, a, input, select, textarea");
    if (focusable) focusable.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    var main = document.getElementById("MainContent");
    if (main) main.removeAttribute("inert");
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest("[data-drawer-open]");
    if (openTrigger) {
      event.preventDefault();
      openDrawer(document.getElementById(openTrigger.getAttribute("data-drawer-open")));
      return;
    }
    var closeTrigger = event.target.closest("[data-drawer-close]");
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer(closeTrigger.closest(".drawer"));
    }
  });

  document.addEventListener("keydown", function (event) {
    var openPanel = $(".drawer.is-open .drawer__panel");
    if (event.key === "Tab" && openPanel) {
      var focusable = $$("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])", openPanel);
      if (focusable.length) {
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }
    if (event.key !== "Escape") return;
    $$(".drawer.is-open").forEach(closeDrawer);
    var search = $("[data-search-overlay].is-open");
    if (search) toggleSearch(false);
  });

  /* ---------------- search overlay ---------------- */
  function toggleSearch(open) {
    var overlay = $("[data-search-overlay]");
    if (!overlay) return;
    overlay.classList.toggle("is-open", open);
    overlay.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) {
      var input = overlay.querySelector('input[name="q"]');
      if (input) input.focus();
    }
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-search-open]")) {
      event.preventDefault();
      toggleSearch(true);
    } else if (event.target.closest("[data-search-close]")) {
      event.preventDefault();
      toggleSearch(false);
    }
  });

  /* ---------------- FAQ accordion ---------------- */
  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-faq-toggle]");
    if (!button) return;
    var expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", expanded ? "false" : "true");
    var panel = document.getElementById(button.getAttribute("aria-controls"));
    if (panel) panel.classList.toggle("is-open", !expanded);
  });

  /* ---------------- product gallery ---------------- */
  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    var gallery = thumb.closest("[data-gallery]");
    var main = $("[data-gallery-main]", gallery);
    if (!main) return;
    main.removeAttribute("srcset");
    main.src = thumb.getAttribute("data-image");
    main.alt = thumb.getAttribute("data-alt") || main.alt;
    $$("[data-gallery-thumb]", gallery).forEach(function (el) {
      el.setAttribute("aria-current", el === thumb ? "true" : "false");
    });
    var count = $("[data-gallery-count]", gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (count) count.textContent = String(thumbs.indexOf(thumb) + 1) + " / " + String(thumbs.length);
  });

  document.addEventListener("click", function (event) {
    var arrow = event.target.closest("[data-gallery-direction]");
    if (!arrow) return;
    var gallery = arrow.closest("[data-gallery]");
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!thumbs.length) return;
    var active = thumbs.findIndex(function (thumb) { return thumb.getAttribute("aria-current") === "true"; });
    var direction = Number(arrow.getAttribute("data-gallery-direction"));
    thumbs[(active + direction + thumbs.length) % thumbs.length].click();
  });

  /* ---------------- product detail tabs ---------------- */
  document.addEventListener("click", function (event) {
    var tab = event.target.closest("[data-product-tab]");
    if (!tab) return;
    var root = tab.closest("[data-product-tabs]");
    var target = tab.getAttribute("data-product-tab");
    $$('[data-product-tab]', root).forEach(function (item) {
      var active = item === tab;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", active ? "true" : "false");
    });
    $$('[data-product-panel]', root).forEach(function (panel) {
      var active = panel.getAttribute("data-product-panel") === target;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });
  });

  /* ---------------- quantity controls ---------------- */
  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-quantity-change]");
    if (!button) return;
    var wrapper = button.closest("[data-quantity]");
    var input = $("input", wrapper);
    if (!input) return;
    var step = parseInt(button.getAttribute("data-quantity-change"), 10);
    var min = parseInt(input.getAttribute("min") || "1", 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------- variant selection ---------------- */
  $$("[data-product-form]").forEach(function (form) {
    var dataEl = $("[data-variants-json]", form.closest("[data-product-root]") || document);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var root = form.closest("[data-product-root]");

    function currentOptions() {
      return $$("[data-option-selector]", root).map(function (group) {
        var checked = group.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }

    function updateVariant() {
      var selected = currentOptions();
      var match = variants.filter(function (variant) {
        return selected.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      })[0];

      var idInput = $("[data-variant-id]", form);
      var submit = $("[data-add-to-cart]", form);
      var priceEl = $("[data-variant-price]", root);
      var compareEl = $("[data-variant-compare]", root);
      var skuEl = $("[data-variant-sku]", root);
      var availabilityEl = $("[data-product-availability]", root);
      var sticky = $("[data-sticky-add]", root);

      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? strings.addToCart : strings.soldOut;
      }
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.classList.remove("hidden");
        } else {
          compareEl.classList.add("hidden");
        }
      }
      if (skuEl) skuEl.textContent = match.sku || "";
      if (availabilityEl) availabilityEl.textContent = match.available ? "In stock" : "Out of stock";
      if (sticky) {
        sticky.disabled = !match.available;
        sticky.textContent = (match.available ? strings.addToCart : strings.soldOut) + " — " + formatMoney(match.price);
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }

      var featured = match.featured_image && match.featured_image.src;
      if (featured) {
        var main = $("[data-gallery-main]", root);
        if (main) {
          main.removeAttribute("srcset");
          main.src = featured;
        }
      }
    }


    $$("[data-option-selector] input", root).forEach(function (input) {
      input.addEventListener("change", updateVariant);
    });
    updateVariant();
  });

  /* ---------------- AJAX cart ---------------- */
  function refreshCartUI() {
    return fetch(cartRoot + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle("hidden", cart.item_count === 0);
        });
        return cart;
      });
  }

  function renderCartDrawer() {
    var drawer = $("#cart-drawer");
    if (!drawer) return refreshCartUI();
    return fetch(cartRoot + "?section_id=cart-drawer")
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var fresh = parsed.querySelector("[data-cart-drawer-content]");
        var target = $("[data-cart-drawer-content]", drawer);
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return refreshCartUI();
      })
      .catch(refreshCartUI);
  }

  // Add to cart
  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-product-form]");
    if (!form) return;
    event.preventDefault();
    var submit = $("[data-add-to-cart]", form);
    var original = submit ? submit.textContent : "";
    if (submit) { submit.disabled = true; submit.textContent = strings.adding; }

    fetch(routes.cart_add_url || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{
          id: Number(new FormData(form).get("id")),
          quantity: Number(new FormData(form).get("quantity") || 1)
        }]
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return renderCartDrawer();
      })
      .then(function () {
        openDrawer($("#cart-drawer"));
      })
      .catch(function (error) {
        console.error(error);
        window.alert(error.message || strings.cartError);
      })
      .finally(function () {
        if (submit) { submit.disabled = false; submit.textContent = original; }
      });
  });

  // Quantity change / remove inside cart drawer and cart page
  function changeLine(key, quantity, isDrawer) {
    return fetch(routes.cart_change_url || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (isDrawer) return renderCartDrawer();
        window.location.reload();
      });
  }

  document.addEventListener("click", function (event) {
    var remove = event.target.closest("[data-cart-remove]");
    if (!remove) return;
    event.preventDefault();
    changeLine(remove.getAttribute("data-cart-remove"), 0, !!remove.closest("#cart-drawer"));
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-cart-quantity]");
    if (!input) return;
    changeLine(input.getAttribute("data-cart-quantity"), Number(input.value), !!input.closest("#cart-drawer"));
  });

  /* ---------------- collection sorting ---------------- */
  var sortSelect = $("[data-sort-by]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }

  /* ---------------- product recommendations ---------------- */
  var recs = document.querySelector("[data-recommendations]");
  if (recs && recs.getAttribute("data-url")) {
    fetch(recs.getAttribute("data-url"))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var section = parsed.querySelector(".section");
        if (section) recs.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  refreshCartUI();
  /* ---------------- wishlist (localStorage) ---------------- */
  var WISHLIST_KEY = "kita-wishlist";

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function syncWishlistUI() {
    var list = readWishlist();
    $$("[data-wishlist-toggle]").forEach(function (button) {
      var active = list.indexOf(button.getAttribute("data-wishlist-toggle")) !== -1;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      button.setAttribute("aria-label", active ? "Remove from wishlist" : "Add to wishlist");
      var label = button.querySelector("span");
      if (label) label.textContent = active ? "Remove from wishlist" : "Add to wishlist";
    });
    var page = $("[data-wishlist-page]");
    if (!page) return;
    var shown = 0;
    $$("[data-wishlist-item]", page).forEach(function (item) {
      var active = list.indexOf(item.getAttribute("data-wishlist-item")) !== -1;
      item.hidden = !active;
      if (active) shown++;
    });
    var grid = $("[data-wishlist-grid]", page);
    var empty = $("[data-wishlist-empty]", page);
    if (grid) grid.hidden = shown === 0;
    if (empty) empty.hidden = shown !== 0;
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-wishlist-toggle]");
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute("data-wishlist-toggle");
    var list = readWishlist();
    var index = list.indexOf(handle);
    if (index === -1) list.push(handle); else list.splice(index, 1);
    writeWishlist(list);
    syncWishlistUI();
  });

  syncWishlistUI();

  /* ---------------- sticky mobile add to cart ---------------- */
  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-sticky-add]");
    if (!trigger) return;
    event.preventDefault();
    var button = $("[data-product-root] [data-product-form] [data-add-to-cart]");
    if (button) button.click();
  });
})();
